import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import theme from "../../index.scss";
import ReactECharts from "echarts-for-react";

const TriggerBarChart = ({ data, userName, splitView }) => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();

  const tTrigger = (factor) => {
    const categories = ["wellness","travel","screen_time","environmental","dietary","situational","other"];
    const safe = (factor || "").trim().toLowerCase()
      .replace(/ /g,"_").replace(/\//g,"_").replace(/,/g,"")
      .replace(/:/g,"").replace(/'/g,"").replace(/[()]/g,"").replace(/-/g,"_")
      .substring(0, 60);
    for (const cat of categories) {
      const key = `trigger.${cat}.${safe}`;
      const translated = t(key);
      if (translated !== key) return translated;
    }
    return factor;
  };

  const calNumOfEachTriggerFactor = (data) => {
    const count = {};
    data.forEach((item) => {
      const elements = item.description.split(", ");
      elements.forEach((element) => {
        count[element] = (count[element] || 0) + 1;
      });
    });
    const result = Object.entries(count).map(([name, value]) => ({ name, value }));
    return result.sort((a, b) => b.value - a.value).slice(0, 5);
  };

  const truncateText = (text, maxLength = 30) =>
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  const top5 = calNumOfEachTriggerFactor(data);

  const option = {
    title: {
      text: t("toptriggers.title"),
      left: "center",
      textStyle: { fontSize: "1.2rem", color: dark ? theme.darkModeText : theme.black },
      subtext: top5.length === 0
        ? t("notrackingdata.0")
        : `${splitView ? `(${userName})` : ""}`,
      subtextStyle: { fontSize: "1.3rem", color: dark ? theme.darkModeText : theme.primary },
    },
    tooltip: { trigger: "item" },
    xAxis: {
      type: "value",
      axisLabel: { fontSize: 16, color: dark ? theme.darkModeText : theme.black },
    },
    grid: { left: "5%", containLabel: true },
    yAxis: {
      type: "category",
      axisLabel: {
        fontSize: 16,
        color: dark ? theme.darkModeText : theme.black,
        formatter: (value) => truncateText(value),
      },
      data: top5.map((item) => tTrigger(item.name)).reverse(),
    },
    series: [{ data: top5.map((item) => item.value).reverse(), type: "bar" }],
  };

  return <ReactECharts option={option} style={{ minHeight: "25vh" }} />;
};

export default TriggerBarChart;